import { cn } from "~/lib/utils";

interface PanelSectionRootProps {
  children: React.ReactNode;
  className?: string;
}

export function PanelSectionRoot({ children, className }: PanelSectionRootProps) {
  return <div className={cn("space-y-3 empty:hidden", className)}>{children}</div>;
}
